module.exports = __webpack_public_path__ + "img/13.d2f5e331.jpeg";